// import { Outlet, Navigate } from 'react-router-dom'

// function ProtectedRoute({ isAuthenticated }) {
//   return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />
// }

// export default ProtectedRoute


import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';


function ProtectedRoute({ isAuthenticated, userRole, allowedRoles }) {
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/not-found" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;